import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ServerResponseKeys } from '../../../../api/Constants';
import { getObjectValues, hasObjectValues } from '../../../../utils/object';
import { setActionCommand, setActionCommandLoading } from '../../../slices/actionCommands/actionCommands';
import store from '../../../store';
import { validateActionCommand } from './validations';

var handleActionsCommands = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(actions) {
    var actionsValidated;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store.dispatch(setActionCommandLoading(true));
            _context.next = 3;
            return validateActionCommand(actions);

          case 3:
            actionsValidated = _context.sent;
            if (actionsValidated.length > 0) store.dispatch(setActionCommand({
              actions: actionsValidated
            }));
            store.dispatch(setActionCommandLoading(false));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleActionsCommands(_x) {
    return _ref.apply(this, arguments);
  };
}();

var handleInterceptors = function handleInterceptors(data) {
  // add others handler in the future
  if (data[ServerResponseKeys.ACTIONS_COMANDS] && hasObjectValues(data[ServerResponseKeys.ACTIONS_COMANDS])) handleActionsCommands(getObjectValues(data[ServerResponseKeys.ACTIONS_COMANDS]));
};

export default handleInterceptors;